import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import TrackingService from '@/core/tracking.service';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GetCutsheetLink',
  setup(__props) {

const product = computed<ProductBaseViewModel<VariantBaseViewObject>>(() => store.getters['catalog/product']);

function openTab() {
    window.open(product.value.cutsheetUrl);
    TrackingService.event('Mini page', 'Download cutsheet');
}

return { __sfc: true,product, openTab }
}

})